import type { ReactNode } from 'react';

import type { StylesConfig } from './style.types';

// =============================================================================
// Table Density
// =============================================================================

export type TableDensity = 'compact' | 'comfortable' | 'default' | 'wide';

/**
 * Row heights in pixels for each density level.
 * Based on Tailwind classes: compact=h-5 (1.25rem), comfortable=h-8 (2rem),
 * default=h-10 (2.5rem), wide=h-12 (3rem). Values assume 16px base font.
 */
export const DENSITY_ROW_HEIGHTS: Record<TableDensity, number> = {
  compact: 20, // 1.25rem
  comfortable: 32, // 2rem
  default: 40, // 2.5rem
  wide: 48, // 3rem
};

// =============================================================================
// Settings Configuration (parsed from JSX children)
// =============================================================================

export interface SettingsConfig {
  density: TableDensity;
  stickyHeader: { enabled: boolean; height?: string };
  cache: { sizing?: boolean; sorting?: boolean };
  virtualize?: { enabled: boolean; overscan?: number; estimateSize?: number };
  dragScroll?: boolean;
  styles: StylesConfig;
}

// =============================================================================
// Settings Component Props
// =============================================================================

export interface SettingsProps {
  children?: ReactNode;
}

export interface DensityProps {
  value: TableDensity;
}

export interface StickyHeaderProps {
  height?: string;
}

export interface CacheProps {
  properties: ('sizing' | 'sorting')[];
}

export interface VirtualizeProps {
  overscan?: number;
  estimateSize?: number;
}
